export default "__VITE_ASSET__fagMNZj1__"